var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"branding-templates"}},[_c('h2',[_vm._v("\n    Templates\n  ")]),_vm._v(" "),_c('branding-nav'),_vm._v(" "),_c('pagination',{ref:"pagination",attrs:{"resourceUrl":_vm.resourceUrl,"orderBy":"created_at","orderType":"DESC","attrIncludes":""},scopedSlots:_vm._u([{key:"paged_item",fn:function(item){return [_c('router-link',{staticClass:"list-group-item list-group-item-action",attrs:{"to":{
          name: 'branding_template',
          params: {
            brandingTemplateId: item.id
          }
        }}},[_vm._v("\n        "+_vm._s(item.name)+"\n        "),(item.inactive)?_c('span',{staticClass:"badge badge-secondary"},[_vm._v("\n          Inactive\n        ")]):_vm._e()])]}}])}),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary btn-block",attrs:{"to":{
      name: 'create_branding_template'
    },"tag":"button"}},[_vm._v("\n    Create Template\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dcf41cc6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BrandingTemplates.vue
// module id = 1285
// module chunks = 1